import { Injectable } from '@angular/core';

export type LnaEstado = 'granted' | 'prompt' | 'denied' | 'unsupported';

/**
 * Permiso de Chrome "Acceder a otras aplicaciones y servicios de este dispositivo"
 * (Local Network Access), requerido para que el sitio público pueda llamar al Gateway en localhost.
 */
@Injectable({
  providedIn: 'root'
})
export class LocalNetworkPermissionService {

  // Chrome ha renombrado el permiso entre versiones; los nombres no soportados lanzan TypeError
  private static readonly NOMBRES = ['loopback-network', 'local-network-access', 'local-network'];

  private statusPromise: Promise<PermissionStatus | null> | null = null;

  // PermissionStatus es "vivo": su state se actualiza y emite 'change' al cambiar el permiso.
  // Devuelve null si el navegador no soporta el permiso (Firefox, Safari, Chrome antiguo).
  getStatus(): Promise<PermissionStatus | null> {
    if (!this.statusPromise) {
      this.statusPromise = this.query();
    }
    return this.statusPromise;
  }

  async getState(): Promise<LnaEstado> {
    const status = await this.getStatus();
    return status ? status.state as LnaEstado : 'unsupported';
  }

  private async query(): Promise<PermissionStatus | null> {
    if (!navigator.permissions?.query) {
      return null;
    }
    for (const name of LocalNetworkPermissionService.NOMBRES) {
      try {
        return await navigator.permissions.query({ name } as unknown as PermissionDescriptor);
      } catch {
        // nombre no soportado por este navegador: probar el siguiente
      }
    }
    return null;
  }
}
